import * as Device from 'expensify-common/lib/Device';

export default Device.getOSAndName;
